import locale from './locale'
import reporter from './reporter'

const env = 'dev'
const config = {
  thaiairways: {
    serverUrl: 'https://thaiairways.herokuapp.com/',
    appid: '710306462496316'
  },
  dev: {
    serverUrl: 'https://api-enterprise.zwiz.app/',

    webhookUrl: 'https://webhook-enterprise.zwiz.app/',
    eventTrackingUrl: 'https://api-gateway-enterprise.zwiz.app/event-tracking',
    apiGatewayUrl: 'https://api-gateway-enterprise.zwiz.app/',
    appid: '324115987996476'
  }
}

export default {
  serverUrl: config[env].serverUrl,
  webhookUrl: config[env].webhookUrl,
  eventTrackingUrl: config[env].eventTrackingUrl,
  apiGatewayUrl: config[env].apiGatewayUrl,
  facebookUrl: 'https://graph.facebook.com/',
  shopUrl: 'https://shop.enterprise.zwiz.app/',
  appid: config[env].appid,

  theme: {
    logo: '/static/img/logo_ananda_white.svg',
    small_logo: '/static/img/logo_ananda_icon_white.svg',
    short_small_logo: '/static/img/logo-small-mobile.png',
    hide_zwiz: false,
    email_contact: 'sales@zwiz.ai',
    header_color: 'white',
    header_background_color: '#504F4F',
    brand_color: '#0500AA',
    secondary_color: '#ff687f' // #ff687f
  },

  fb_scope:
    'email,pages_show_list,read_page_mailboxes,pages_messaging,page_events,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_ads,pages_manage_posts,pages_manage_engagement,public_profile,instagram_basic,instagram_manage_messages,instagram_manage_comments,ads_management,ads_read,pages_utility_messaging',

  reporter: reporter,
  locale: locale.locale
}



// WEBPACK FOOTER //
// ./src/config/index.js